import React from "react";
import styles from "./FeatureHeader.module.css";

/**
 * FeatureHeader renders the branded "icon + feature name" lockup at the top of
 * a feature page. The source artwork lives in /public/images/feature-headers/.
 *
 * The lockup image IS the page's primary heading, so it renders as an <h1> by
 * default — the img's alt text becomes the accessible heading name, preserving
 * a correct document outline for screen readers. Pass `as` to use a different
 * element/heading level on pages that already have their own <h1>.
 *
 * Props:
 *  - src:   path to the header lockup image (required)
 *  - alt:   accessible label (required)
 *  - as:    element to render as — "h1" (default), "h2", "div", …
 *  - align: "left" (default) or "center"
 *  - className / style: optional overrides for spacing in a given page
 */
export default function FeatureHeader({
  src,
  alt,
  as: Tag = "h1",
  align = "left",
  className = "",
  style,
}) {
  return (
    <Tag
      className={`${styles.featureHeader} ${
        align === "center" ? styles.center : ""
      } ${className}`}
      style={style}
    >
      <img src={src} alt={alt} className={styles.featureHeaderImg} />
    </Tag>
  );
}
